import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { League } from '../../../../sdk/model';
import { ChartDataPoint } from './types';
import { TabPanel } from './TabPanel';
import { PowerRankingCharts } from './charts/PowerRankingCharts';
import { RosterManagementChartsWithData } from './charts/RosterManagementChartsWithData';

interface AnalyticsTabProps {
  league: League;
  chartData: ChartDataPoint[];
}

function a11yPropsAnalytics(index: number) {
  return {
    id: `analytics-tab-${index}`,
    'aria-controls': `analytics-tabpanel-${index}`,
  };
}

export function AnalyticsTab({ league, chartData }: AnalyticsTabProps) {
  const [analyticsTabValue, setAnalyticsTabValue] = React.useState(0);

  const handleAnalyticsTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setAnalyticsTabValue(newValue);
  };

  return (
    <Box>
      <Tabs 
        value={analyticsTabValue} 
        onChange={handleAnalyticsTabChange} 
        aria-label="analytics tabs"
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
      >
        <Tab label="Power Rankings" {...a11yPropsAnalytics(0)} />
        <Tab label="Roster Management" {...a11yPropsAnalytics(1)} />
        {/* Future tabs will go here - when we have real data */}
        {/* <Tab label="Weekly Performance" {...a11yPropsAnalytics(2)} /> */}
        {/* <Tab label="Transaction Analysis" {...a11yPropsAnalytics(3)} /> */}
        {/* <Tab label="Head-to-Head" {...a11yPropsAnalytics(4)} /> */}
        {/* <Tab label="Advanced Analytics" {...a11yPropsAnalytics(5)} /> */}
      </Tabs>

      <TabPanel value={analyticsTabValue} index={0}>
        <PowerRankingCharts chartData={chartData} />
      </TabPanel>

      <TabPanel value={analyticsTabValue} index={1}>
        <RosterManagementChartsWithData league={league} chartData={chartData} />
      </TabPanel>

      {/* Future tab panels will go here - when we have real data */}
    </Box>
  );
}
